import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import SwiperCore, { Navigation, Pagination, EffectCoverflow } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";

SwiperCore.use([Navigation, Pagination, EffectCoverflow]);

import IconArrow from "../icons/arrow";
import Image from "../image";
import SwiperWrapper from "./SwiperWrapper";

class Gallery extends Component {
    _renderCoverflow() {
        const { data, name, width } = this.props;

        let className = "px-70 relative";
        if (width) className += " " + width;

        return (
            <div className={className}>
                <Swiper
                    effect="coverflow"
                    centeredSlides
                    slidesPerView={1}
                    breakpoints={{
                        1024: {
                            slidesPerView: 2,
                        },
                    }}
                    navigation={{
                        nextEl: ".swiper-next",
                        prevEl: ".swiper-prev",
                    }}
                    coverflowEffect={{
                        depth: 90,
                        modifier: 10,
                        rotate: 0,
                        stretch: 0,
                        slideShadows: false,
                    }}
                >
                    {data.map((item, index) => (
                        <SwiperSlide key={index}>
                            <Image
                                alt={item.alt || name}
                                url={item.url}
                                aspectRatio={"aspect-ratio-3/2"}
                            />
                        </SwiperSlide>
                    ))}
                </Swiper>
                <div className="swiper-next cursor-pointer absolute right-0 p-16 top-1/2 -mt-30 -mr-16">
                    <IconArrow
                        style={{ color: "#ff83ff" }}
                        className="transform rotate-90 w-26 h-26"
                    />
                </div>
                <div className="swiper-prev cursor-pointer absolute left-0 p-16 top-1/2 -mt-30 -ml-16">
                    <IconArrow
                        style={{ color: "#ff83ff" }}
                        className="transform -rotate-90 w-26 h-26"
                    />
                </div>
            </div>
        );
    }

    _renderCoverflowMobile() {
        const { data, name, width } = this.props;

        let className = "relative";
        if (width) className += " " + width;

        let pagination = false;

        let bulletWidth = 40;
        let dynamicWidth =
            (window.innerWidth - 32 - 8 * (data.length - 1)) / data.length;
        if (bulletWidth > dynamicWidth) {
            bulletWidth = dynamicWidth;
        }

        if (data.length > 1) {
            pagination = {
                bulletClass: "custom-1-pagination-bullet",
                bulletActiveClass: "custom-1-pagination-bullet-active",
                clickable: true,
                renderBullet: function (index, className) {
                    return (
                        '<span style="width: ' +
                        bulletWidth +
                        'px;" class="' +
                        className +
                        '">' +
                        "</span>"
                    );
                },
            };
        }

        return (
            <div className={className}>
                <Swiper
                    centeredSlides={true}
                    slidesPerView={1}
                    loop={false}
                    pagination={pagination}
                >
                    {data.map((item, index) => (
                        <SwiperSlide key={index}>
                            <Image
                                alt={item.alt || name}
                                url={item.url}
                                aspectRatio={"aspect-ratio-191/128"}
                            />
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        );
    }

    _renderVideo() {
        const { data, width } = this.props;

        let className = "px-70 xl:w-7/12 relative";
        if (width) className += " " + width;

        return (
            <div className={className}>
                <video width="100%" controls>
                    <source src={data} type="video/mp4" />
                </video>
            </div>
        );
    }

    render() {
        const {
            showCoverflow,
            caption,
            isVideo,
            width,
            padding,
            data,
            autoHeight,
            customStyle,
            name,
        } = this.props;

        if (!data || (data && data.length <= 0)) return null;

        if (showCoverflow)
            return (
                <div>
                    <div className="hidden xl:block">
                        {this._renderCoverflow()}
                    </div>
                    <div className="xl:hidden">
                        {this._renderCoverflowMobile()}
                    </div>
                </div>
            );

        if (isVideo) return this._renderVideo();

        let className = "xl:w-9/12 relative";
        if (width) className += " " + width;
        if (padding) className += " " + padding;

        let pagination = false;

        let bulletWidth = 40;
        let dynamicWidth =
            (window.innerWidth - 32 - 8 * (data.length - 1)) / data.length;
        if (bulletWidth > dynamicWidth) {
            bulletWidth = dynamicWidth;
        }

        if (data.length > 1) {
            pagination = {
                bulletClass: "custom-2-pagination-bullet",
                bulletActiveClass: "custom-2-pagination-bullet-active",
                clickable: true,
                renderBullet: function (index, className) {
                    return (
                        '<span style="width: ' +
                        bulletWidth +
                        'px;" class="' +
                        className +
                        '">' +
                        "</span>"
                    );
                },
            };
        }

        return (
            <div className={className}>
                <div className="hidden xl:block" style={customStyle}>
                    <SwiperWrapper
                        images={data}
                        autoHeight={autoHeight}
                        pagination={false}
                        arrowsBottom={this.props.arrowsBottom}
                        aspectRatio={"aspect-ratio-98/65"}
                    />
                </div>
                <div className="xl:hidden">
                    <SwiperWrapper
                        images={data}
                        autoHeight={autoHeight}
                        pagination={pagination}
                        arrowsBottom={this.props.arrowsBottom}
                        aspectRatio={"aspect-ratio-191/128"}
                    />
                </div>
                {caption && <p className="text-center -mt-20">{caption}</p>}
            </div>
        );
    }
}

Gallery.defaultProps = {
    showCoverflow: false,
    width: "w-full",
    isVideo: false,
    autoHeight: false,
    arrowsBottom: false,
    padding: "",
    data: null,
    caption: null,
    customStyle: {},
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(Gallery);
